<template>
  <div class="detail-page">
    <!-- 顶部导航 -->
    <div class="header">
      <button class="back-btn" @click="goBack">←</button>
      <span class="title">任务详情</span>
      <span class="placeholder"></span>
    </div>

    <!-- 滚动内容 -->
    <div class="scroll-container">
      <div v-if="!detail.name" class="empty-state">
        <van-icon name="search" size="80" color="#4A90D9" />
        <span>暂无任务详情</span>
      </div>

      <div v-else>
        <div class="info-card">
          <div class="info-row">
            <span class="label">项目名称</span>
            <span class="value">{{ detail.name }}</span>
          </div>
          <div class="info-row">
            <span class="label">发布企业</span>
            <span class="value">{{ detail.merchantName }}</span>
          </div>
          <div class="info-row">
            <span class="label">薪酬</span>
            <span class="value amount">{{ detail.salaryRange }}</span>
          </div>
          <div class="info-row">
            <span class="label">经验要求</span>
            <span class="value">{{ detail.experience || "不限" }}</span>
          </div>
          <div class="info-row desc-row">
            <span class="label">项目描述</span>
            <span class="value">{{ detail.describe || "无" }}</span>
          </div>
          <div class="footer">
            <button
              class="submit-btn"
              @click="signUpProject"
              :disabled="submitting || detail.status == 1"
            >
              {{
                submitting
                  ? "提交中..."
                  : detail.status == 1
                  ? "已报名"
                  : "接受任务"
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { httpPost } from "@/utils/fetch";

export default {
  name: "TaskDetail",
  data() {
    return {
      projectId: "", // 项目ID（报名接口id参数）
      merchantId: "", // 商户ID（报名接口merchantId参数，列表页传过来）
      detail: {
        name: "",
        merchantName: "",
        salaryRange: "",
        experience: "",
        describe: "",
        status: 0, // 报名状态：0未报名 1已报名（接口可能不返回该字段，默认0）
      },
      submitting: false,
    };
  },
  mounted() {
    // 从路由获取列表页传过来的两个参数：项目id、商户merchantId
    this.projectId = this.$route.query.id || "";
    this.merchantId = this.$route.query.merchantId || "";

    if (!this.projectId) {
      Toast.fail("缺少项目ID");
      return;
    }
    this.fetchDetail();
  },
  methods: {
    goBack() {
      this.$router.back();
    },

    // 获取项目详情
    fetchDetail() {
      httpPost("/wechat/wechat/getOneProjectById", { id: this.projectId })
        .then((res) => {
          if (res.code === "0000") {
            const data = res.data;
            this.detail = {
              name: data.name || "",
              merchantName: data.merchantName || "",
              salaryRange: data.salaryRange || "",
              experience: data.experience || "不限",
              describe: data.describe || "",
              status: data.status || 0, // 接口可能不返回status，默认0表示未报名
            };
          } else {
            Toast.fail(res.message || "获取详情失败");
          }
        })
        .catch((err) => {
          console.error("详情接口报错：", err);
          Toast.fail("网络异常，请稍后重试");
        });
    },

    // 报名项目接口
    signUpProject() {
      if (!this.merchantId) {
        Toast.warning("商户ID缺失，请返回列表重新进入");
        return;
      }
      this.submitting = true;
      Toast.loading("提交中...");

      httpPost("/wechat/wechat/signUpProject", {
        id: this.projectId,
        merchantId: this.merchantId,
      })
        .then((res) => {
          Toast.clear();
          this.submitting = false;
          if (res.code === "0000") {
            Toast.success(res.message || "参与成功");
            this.fetchDetail(); // 重新获取详情，更新status状态
          } else {
            Toast.fail(res.message || "报名失败");
          }
        })
        .catch((err) => {
          Toast.clear();
          this.submitting = false;
          console.error("报名接口报错：", err);
          Toast.fail("网络异常，请重试");
        });
    },
  },
};
</script>


<style scoped>
.detail-page {
  height: 100vh;
  overflow: hidden;
  background: #f4f7fd;
  display: flex;
  flex-direction: column;
}

/* 顶部导航 */
.header {
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}
.back-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: #f5f7fa;
  border-radius: 50%;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back-btn:active {
  background: #e8ecf2;
}
.title {
  font-size: 18px;
  font-weight: 600;
  color: #0b1a33;
}
.placeholder {
  width: 36px;
}

/* 滚动区域 */
.scroll-container {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  -webkit-overflow-scrolling: touch;
}

/* 详情卡片 */
.info-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
.info-row {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #f5f7fa;
}
.info-row:last-child {
  border-bottom: none;
}
.desc-row {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f5f7fa;
}
.label {
  width: 90px;
  flex-shrink: 0;
  font-size: 14px;
  color: #7a88a6;
}
.value {
  font-size: 14px;
  color: #1a2332;
  word-break: break-all;
}
.amount {
  color: #e74c5e;
  font-weight: 600;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 20px;
  gap: 16px;
  color: #8a99b0;
  font-size: 16px;
}
.empty-state .van-icon {
  opacity: 0.5;
}

/* 底部按钮栏 */
.footer {
  margin-bottom: 60px;
  margin-top: 20px;
  background: #ffffff;
  padding: 16px 20px;
  /* padding-bottom: constant(safe-area-inset-bottom, 16px);
  padding-bottom: env(safe-area-inset-bottom, 16px); */
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05); */
  /* flex-shrink: 0; */
}
.submit-btn {
  width: 100%;
  height: 48px;
  border: none;
  background: linear-gradient(90deg, #ff7849, #e72c2c);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 24px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.submit-btn:active:not(:disabled) {
  opacity: 0.8;
}
.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #cccccc;
}

/* 手机小屏适配 */
@media (max-width: 480px) {
  .header {
    padding: 12px 16px;
  }
  .scroll-container {
    padding: 12px;
  }
  .info-card {
    padding: 16px;
  }
  .label {
    width: 76px;
  }
  .footer {
    padding: 12px 16px;
    /* padding-bottom: constant(safe-area-inset-bottom, 12px);
    padding-bottom: env(safe-area-inset-bottom, 12px); */
  }
}
</style>